import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Mobicar3Light from './views/Instructions/Mobicar3Light.vue'
import XtagQrCode from './views/Instructions/XtagQrCode.vue'
import Mobicar3compactQrCode from './views/Instructions/Mobicar3compactQrCode.vue'
import AmgxQrCode from './views/Instructions/AmgxQrCode.vue'
import Docs from './views/Docs'
import Privacy from './views/Privacy.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/mobicar3-light-qr-code',
      name: 'mobicar3-light-qr-code',
      component: Mobicar3Light
    },
    {
      path: '/x-tag-qr-code',
      name: 'x-tag-qr-code',
      component: XtagQrCode
    },
    {
      path: '/mobicar3-compact-qr-code',
      name : 'mobicar3-compact-qr-code',
      component: Mobicar3compactQrCode
    },
    {
      path: '/amgx-qr-code',
      name : 'amgx-qr-code',
      component: AmgxQrCode
    },
    {
      path: '/docs',
      name: 'docs',
      component: Docs
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ]
})
